<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/andon/exceptionType/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('yichangleixingbianma')">
						<el-input v-model="yt.conditions.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('yichangleixingmingcheng')">
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zhuangtai')">
						<el-select v-model="yt.conditions.status">
							<el-option :label="$t('youxiao')" :value="1"></el-option>
							<el-option :label="$t('shixiao')" :value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear({orderBy:'code asc'})">{{$t('chongzhi')}}</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" v-if="utils.checkPower('web_andon_management_exception_type_create')" @click="yt.showEditDialog('xinzeng',null,'w1');setDefaultValue()" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()">
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)" v-if="utils.checkPower('web_andon_management_exception_type_update')">
							{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger" v-if="utils.checkPower('web_andon_management_exception_type_delete')"
							@click="yt.remove(scope.row,'/web/andon/exceptionType/delete')">
							{{$t('shanchu')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('erjileixing', scope.row,'w2')" v-if="utils.checkPower('web_andon_management_exception_type_pageSecondLevel')">
							{{$t('erjileixing')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('yichangleixingbianma')" required>
						<el-input v-model.trim="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('yichangleixingmingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('miaoshu')" required>
						<el-input v-model="yt.editObj.describe"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zhuangtai')" required>
						<el-select v-model="yt.editObj.status" @change="$forceUpdate()">
							<el-option :label="$t('youxiao')" :value="1"></el-option>
							<el-option :label="$t('shixiao')" :value="0"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/andon/exceptionType/create')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 编辑 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item class="noborder" :label="$t('yichangleixingbianma')" required>
						<el-input disabled v-model.trim="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('yichangleixingmingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('miaoshu')" required>
						<el-input v-model="yt.editObj.describe"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zhuangtai')" required>
						<el-select v-model="yt.editObj.status">
							<el-option :label="$t('youxiao')" :value="1"></el-option>
							<el-option :label="$t('shixiao')" :value="0"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/andon/exceptionType/update', null, fetchData)" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 查看工单BOM -->
			<template v-if="yt.editObj.action == 'erjileixing'">
				<div class="dialog-scroller">
					<secondary :type="yt.editObj"></secondary>
				</div>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import secondary from '@@/pages/web/andon_management/exception_type/secondary'
	export default {
		name: 'web_andon_management_exception_type_list',
		components: {
			secondary
		},
		data() {
			return {
				columns: [ {
					label: 'yichangleixingbianma',
					prop: 'code',
					width: 130
				}, {
					label: 'yichangleixingmingcheng',
					prop: 'name'
				}, 
				{
					label: 'miaoshu',
					prop: 'describe'
				},
				{
					label: 'zhuangtai',
					prop: 'status',
					type: 'tag',
					tags: {
						0: {
							color: '#909399',
							text: this.$t('shixiao')
						},
						1: {
							color: '#419FFF',
							text: this.$t('youxiao')
						}
					},
				},{
					label: 'caozuo',
					type: 'slot',
					width: 230,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				//表格默认按照异常类型编码升序排序。
				this.yt.conditions = {
					orderBy:'code asc',
				}
				this.yt.get(1)
			}, 300)
		},
		methods: {
		setDefaultValue(){
			this.yt.editObj.status = 1;
		},
		}
	};
</script>
